const HEADING_SELECTOR = ".reveal-heading";
const BODY_SELECTOR = ".reveal-text, dd, .home--hero__tagline, .icon-grid--item, .reveal-section";
const CTA_SELECTOR = "a.btn, button.btn, .btn";

export function initRevealAnimations() {
  const main = document.querySelector("main");
  if (!main) return;

  const prefersReducedMotion = window
    .matchMedia("(prefers-reduced-motion: reduce)")
    .matches;

  const sections = Array.from(main.querySelectorAll("section"));
  if (!sections.length) return;

  const elements = [];

  sections.forEach((section) => {
    // Skip sections that explicitly opt out
    if (section.hasAttribute("data-reveal-disabled")) return;

    const headingEls = Array.from(section.querySelectorAll(HEADING_SELECTOR));
    const bodyEls = Array.from(section.querySelectorAll(BODY_SELECTOR));
    const ctaEls = Array.from(section.querySelectorAll(CTA_SELECTOR));

    let index = 0;

    const addGroup = (group) => {
      group.forEach((el) => {
        if (!el || el.hasAttribute("data-reveal-ignore")) return;
        // Skip list items in distribution lines and product category tabs — don't animate each item
        if (el.matches("li") && (el.closest(".dist-manufacturer-list") || el.closest(".dist-tabs-list"))) return;
        // Skip headings inside tab panels — animate tab content as a unit, not each heading
        if (el.closest(".tab-panel")) return;
        // Staff cards: no animations at all
        if (el.closest(".staff-card")) return;
        // Featured cards & contact white grid: animate the card only, not elements inside it
        if (el.closest(".icon-grid--item") && !el.matches(".icon-grid--item")) return;
        if (el.closest(".contact-item") && !el.matches(".contact-item")) return;
        // Avoid assigning multiple times
        if (el.hasAttribute("data-reveal")) return;
        el.setAttribute("data-reveal", "true");
        el.style.setProperty("--reveal-index", String(index));
        index += 1;
        elements.push(el);
      });
    };

    addGroup(headingEls);
    addGroup(bodyEls);
    addGroup(ctaEls);
  });

  if (!elements.length) return;

  // If user prefers reduced motion, show everything immediately without animation.
  if (prefersReducedMotion) {
    elements.forEach((el) => {
      el.classList.add("reveal-visible");
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.25,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  elements.forEach((el) => observer.observe(el));
}

